import { useState } from "react";
import { deepCopy, updateNestedValue } from "../../../../../../common/services/common.service";
import Popup from "../../../../../../common/components/popup";
import ReconciliationsBasicInfoComponent from "./reconciliation-basic-info.component";

export const ReconciliationPopup = ({ 
  selectedReconciliation,
  closeModal,
  handleSaveReconciliation,
}: any) => {
  console.log('selectedReconciliation', selectedReconciliation)
    const [localAttribute, setLocalAttribute] = useState(deepCopy(selectedReconciliation));

    const handleLocalFormChange = ({path, value}: any) => {
      // setLocalAttribute(prev => ({
      //   ...prev,
      //   [field]: value,
      // }));
      console.log('selectedReconciliation, path, value', selectedReconciliation, path, value)
      const updatedData = updateNestedValue(selectedReconciliation, path, value)
  
      console.log('updatedData', updatedData)
      setLocalAttribute({...updatedData});
    };

    const handleFormSubmit = () => {
      // setSelectedProductSpecificationAttributeItem(localAttribute);
      handleSaveReconciliation(localAttribute)
    };

    return (
      <>
        <Popup onClose={closeModal}>
          <ReconciliationsBasicInfoComponent
            onClose={closeModal}
            handleInnerFormChange={handleLocalFormChange}
            selectedReconciliation={selectedReconciliation}
            handleFormSubmit={handleFormSubmit}
          />
        </Popup>
      </>
    )
  }